import { removeAcutes } from "@/_utils/string.util";
import { Permissions } from "@/common/enums/sharedEnums";
import { store } from "@/store";

import { getUserByPermission } from "../utils/user.utils";

export const useGetUserType = () => {
  const { authReducer } = store.getState();
  const groupLabel = authReducer?.user?.groupInfo?.label;

  const isSuperAdmin = getUserByPermission({
    authReducer,
    permission: Permissions.SUPER_ADMIN_ACTION,
  });

  const isLegimetrie = removeAcutes(
    `${groupLabel?.trim()?.toLowerCase()}`
  )?.includes("legimetrie");

  const canViewGroup = getUserByPermission({
    authReducer,
    permission: Permissions.GROUP_GET,
  });

  const canCreateGroup = getUserByPermission({
    authReducer,
    permission: Permissions.GROUP_CREATE,
  });

  const canUpdateGroup = getUserByPermission({
    authReducer,
    permission: Permissions.GROUP_UPDATE,
  });

  const canDeleteGroup = getUserByPermission({
    authReducer,
    permission: Permissions.GROUP_DELETE,
  });

  const canViewAgency = getUserByPermission({
    authReducer,
    permission: Permissions.AGENCY_GET,
  });

  const canCreateAgency = getUserByPermission({
    authReducer,
    permission: Permissions.AGENCY_CREATE,
  });

  const canUpdateAgency = getUserByPermission({
    authReducer,
    permission: Permissions.AGENCY_UPDATE,
  });

  const canDeleteAgency = getUserByPermission({
    authReducer,
    permission: Permissions.AGENCY_DELETE,
  });

  const canViewTeam = getUserByPermission({
    authReducer,
    permission: Permissions.TEAM_GET,
  });

  const canCreateTeam = getUserByPermission({
    authReducer,
    permission: Permissions.TEAM_CREATE,
  });

  const canUpdateTeam = getUserByPermission({
    authReducer,
    permission: Permissions.TEAM_UPDATE,
  });

  const canDeleteTeam = getUserByPermission({
    authReducer,
    permission: Permissions.TEAM_DELETE,
  });

  const canViewUser = getUserByPermission({
    authReducer,
    permission: Permissions.USER_GET,
  });

  const canCreateUser = getUserByPermission({
    authReducer,
    permission: Permissions.USER_CREATE,
  });

  const canUpdateUser = getUserByPermission({
    authReducer,
    permission: Permissions.USER_UPDATE,
  });

  const canDeleteUser = getUserByPermission({
    authReducer,
    permission: Permissions.USER_DELETE,
  });

  return {
    isSuperAdmin,
    isLegimetrie,
    canViewGroup,
    canCreateGroup,
    canUpdateGroup,
    canDeleteGroup,
    canViewAgency,
    canCreateAgency,
    canUpdateAgency,
    canDeleteAgency,
    canViewTeam,
    canCreateTeam,
    canUpdateTeam,
    canDeleteTeam,
    canViewUser,
    canCreateUser,
    canUpdateUser,
    canDeleteUser,
  };
};
